module.exports = __webpack_public_path__ + "img/icon_002@2x.9be718c4.png";